import React from 'react'
import { Modal, Form, Select, Input } from 'antd'

interface SendNotificationModalProps {
    open: boolean
    onCancel: () => void
    onSend: (values: any) => void
}

export const SendNotificationModal: React.FC<SendNotificationModalProps> = ({ open, onCancel, onSend }) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.validateFields().then((values) => {
            onSend(values)
            form.resetFields()
        })
    }

    return (
        <Modal
            title="Send New Notification"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            width={600}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="Recipient Type"
                    name="recipientType"
                    rules={[{ required: true, message: 'Please select recipient type' }]}
                >
                    <Select placeholder="Select recipient type">
                        <Select.Option value="user">Specific User</Select.Option>
                        <Select.Option value="merchant">Specific Merchant</Select.Option>
                        <Select.Option value="all_users">All Users</Select.Option>
                        <Select.Option value="all_merchants">All Merchants</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Recipient"
                    name="recipient"
                    rules={[{ required: true, message: 'Please enter recipient' }]}
                >
                    <Input placeholder="Email, phone, or user ID" />
                </Form.Item>
                <Form.Item
                    label="Channel"
                    name="channel"
                    rules={[{ required: true, message: 'Please select channel' }]}
                >
                    <Select placeholder="Select notification channel">
                        <Select.Option value="email">📧 Email</Select.Option>
                        <Select.Option value="sms">💬 SMS</Select.Option>
                        <Select.Option value="push">🔔 Push Notification</Select.Option>
                        <Select.Option value="in-app">📱 In-App</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Type"
                    name="type"
                    rules={[{ required: true, message: 'Please select type' }]}
                >
                    <Select placeholder="Select notification type">
                        <Select.Option value="info">Info</Select.Option>
                        <Select.Option value="success">Success</Select.Option>
                        <Select.Option value="warning">Warning</Select.Option>
                        <Select.Option value="error">Error</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true, message: 'Please enter title' }]}
                >
                    <Input placeholder="Notification title" />
                </Form.Item>
                <Form.Item
                    label="Message"
                    name="message"
                    rules={[{ required: true, message: 'Please enter message' }]}
                >
                    <Input.TextArea rows={4} placeholder="Notification message" />
                </Form.Item>
            </Form>
        </Modal>
    )
}
